import React, {ReactElement, ReactNode, useState} from 'react';
import {useMount} from 'ui/effects/useMount';
import {lazy} from 'shared/utils/lazy';

interface Props {
  children: ReactNode;
}

export function ShowAfterMount({children}: Props): ReactElement {
  const [mounted, setMounted] = useState(false);
  useMount(lazy(setMounted, true));
  return mounted && <>{children}</>;
}
